import { useState } from 'react';
import { IconButton, IconThumbsDown, IconThumbsUp } from '@lmig/lmds-react-icons';
import { sendAIAnswerFeedback } from '../CoveoAnalytics';

interface IAIAnswerFeedbackProps {
  query: string;
  answer: string;
}

export function AIAnswerFeedback({ query, answer }: IAIAnswerFeedbackProps) {
  const [rating, setRating] = useState<boolean | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitRating = async (helpful: boolean) => {
    if (rating !== null || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await sendAIAnswerFeedback(query, answer, helpful);
      setRating(helpful);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ai-answer-feedback" aria-label="Rate this AI answer">
      <span>Was this answer helpful?</span>
      <IconButton
        className="ai-answer-feedback-button"
        background="transparent"
        aria-label="Thumb up this answer"
        aria-pressed={rating === true}
        disabled={isSubmitting || rating !== null}
        onClick={() => void submitRating(true)}
      >
        <IconThumbsUp size="16" aria-hidden="true" />
      </IconButton>
      <IconButton
        className="ai-answer-feedback-button"
        background="transparent"
        aria-label="Thumb down this answer"
        aria-pressed={rating === false}
        disabled={isSubmitting || rating !== null}
        onClick={() => void submitRating(false)}
      >
        <IconThumbsDown size="16" aria-hidden="true" />
      </IconButton>
      {rating !== null && <span role="status">Thanks for your feedback.</span>}
    </div>
  );
}